// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2fI2Y","amount":"Amount_amount__2AaD5","tip":"Amount_tip__3TS9-","tipHeader":"Amount_tipHeader__1Kdp8","tipsWrap":"Amount_tipsWrap__23mrc"};